import React, { useEffect, useMemo, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getMarcas } from "../../api/Marcas/marcaApi";
import { normalizeMarcaOptions } from "../../utils/meetingRecorder";
import { meetingAutocompleteSx } from "./meetingUiStyles";

export default function MeetingBrandSelect({
  value = "",
  onChange,
  disabled = false,
  autoFocus = false,
  margin = "none",
}) {
  const { t } = useTranslation();
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getMarcas()
      .then((rows) => {
        if (!cancelled) setOptions(normalizeMarcaOptions(rows));
      })
      .catch(() => {
        if (!cancelled) setOptions([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const selected = useMemo(
    () =>
      options.find((o) => o.name === value) ||
      (value ? { id: null, name: value } : null),
    [options, value],
  );

  const mergedOptions = useMemo(() => {
    if (!value || options.some((o) => o.name === value)) return options;
    return [{ id: null, name: value }, ...options];
  }, [options, value]);

  return (
    <Autocomplete
      sx={meetingAutocompleteSx}
      options={mergedOptions}
      loading={loading}
      disabled={disabled}
      value={selected}
      onChange={(_, next) => onChange(next?.name || "")}
      getOptionLabel={(option) => option?.name || ""}
      isOptionEqualToValue={(a, b) => a?.name === b?.name}
      autoHighlight
      renderInput={(params) => (
        <TextField
          {...params}
          autoFocus={autoFocus}
          margin={margin}
          label={t("Meetings.customer")}
          placeholder={t("Meetings.customerPlaceholder")}
          fullWidth
        />
      )}
    />
  );
}
